import { UGEStickerCategory } from '../types'

export function labelFromStickerCategory(category: UGEStickerCategory) {
    switch (category) {
        case 'giphytrending':
            return 'Trending'
        case 'giphyfavorites':
            return 'Favorites'
        case 'effects':
            return 'Effects'
        case 'emoji':
            return 'Emoji'
        case 'accessories':
            return 'Accessories'
        case 'party':
            return 'Party'
        case 'holidays':
            return 'Holidays'
    }
}

export function categoryFromSearchTerm(term: string): UGEStickerCategory | null {
    switch (term) {
        case 'accessories':
            return 'accessories'
        case 'effects':
            return 'effects'
        case 'emoji':
            return 'emoji'
        case 'giphyfavorites':
            return 'giphyfavorites'
        case 'giphytrending':
            return 'giphytrending'
        case 'holidays':
            return 'holidays'
        case 'party':
            return 'party'
        default:
            return null
    }
}
